// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__MvaVG","title":"Images45_title__1f8xR","images":"Images45_images__9soat"};